import { get } from 'lodash';
import axiosClient from './axios';
import { ApiError, throwIfServerError } from './errors';

const freelanceApi = {
  getAll(params) {
    try {
      const url = '/v1/admin/account/listing';
      return axiosClient.get(url, { params });
    } catch (error) {}
  },
  getAllSaved(params) {
    try {
      const url = '/v1/account/listingSaved';
      return axiosClient.get(url, { params });
    } catch (error) {}
  },
  getAllByStatus(params) {
    try {
      const url = '/v1/account/listingByStatus';
      return axiosClient.get(url, { params });
    } catch (error) {}
  },
  getRequested(params) {
    try {
      const url = '/v1/match/getRequest';
      const res = axiosClient.post(url, params);
      return res;
    } catch (error) {}
  },
  getDeleted(params) {
    try {
      const url = '/v1/admin/account/getDeleted';
      return axiosClient.get(url, { params });
    } catch (error) {}
  },
};

const freelanceDetailApi = async (userId) => {
  return axiosClient.get(`/v1/user/${userId}/detail`);
};

const savedToList = async (userCode, type = 'user') => {
  return axiosClient.post('/v1/saved/add', {
    refCode: userCode,
    type,
  });
};

const unSavedToList = async (userCode, type = 'user') => {
  return axiosClient.put('/v1/saved/unSave', {
    refCode: userCode,
    type,
  });
};

const freelanceCountApi = async () => {
  return axiosClient.get(`v1/user/count?status=hired,request`);
};
const setTalentCandidates = async ({ type, codes }) => {
  return axiosClient.post(`v1/admin/set-talent-candidates`, {
    type,
    codes,
  });
};
const removeTalentCandidates = async ({ type, codes }) => {
  return axiosClient.post(`v1/admin/remove-talent-candidates`, {
    type,
    codes,
  });
};

const FEATURED_ERROR = 'Update featured talent failed';

/** @returns {Promise<{ codes: string[], isFeatured: boolean, matched: number, modified: number }>} */
const setFeaturedTalents = async ({ codes, isFeatured }) => {
  const response = await axiosClient.post(`v1/admin/set-featured-talents`, {
    codes,
    isFeatured,
  });
  throwIfServerError(response, FEATURED_ERROR);
  const result = get(response, 'data');
  if (typeof get(result, 'isFeatured') !== 'boolean') throw new ApiError(0, FEATURED_ERROR);
  return result;
};

export { removeTalentCandidates, setTalentCandidates, setFeaturedTalents, freelanceApi, freelanceDetailApi, freelanceCountApi, savedToList, unSavedToList };
